"use strict";

/**
 * Sammelt alle URL-Parameter und gibt diese als Objekt zurück.
 */
module.exports = function getQueryParameters() {
    let urls = [
        // Regular URL-Parameters
        decodeURIComponent(window.location.search.substring(1)),
        // #?foo=bar Syntax
        decodeURIComponent(window.location.hash.substring(2))
    ];

    let parameters = {};

    for (let i = 0; i < urls.length; i++) {
        let variables = urls[i].split('&');
        for (let j = 0, part; part = variables[j]; j++) {
            var keyvalue = part.split('=');
            parameters[keyvalue[0]] = keyvalue[1];
        }
    }

    return parameters;
};



// WEBPACK FOOTER //
// /Users/bm/app/code/jsapps/modules/queryparams.js